import React, { Component } from "react";
// core components
import MUIDataTable from "mui-datatables";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import _ from "lodash";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Box } from "@material-ui/core";
import { fetchVesselPtmSource } from "../../api/portal";
import Language from "@material-ui/icons/Language";
const styles = theme => ({
  cardText: {
    fontWeight: 500,
    textAlign: "end"
  },
  cardTitle: {
    fontSize: "20px"
  },
  cardInfo: {
    fontSize: "30px",
    paddingRight: "20px"
  },
  cardUpdateInfo: {
    fontSize: "13px",
    color: "grey",
    margin: 0,
    padding: 0
  },
  cardHeader: {
    display: "Flex",
    flexDirection: "row",
    gap: "10px"
  },
  iconBox: {
    width: "50px",
    height: "50px",
    borderRadius: "5px",
    position: "absolute",
    marginTop: "-30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#4ba34f"
  }
});

class Onoffhiretable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      shiptracker: [],
      selectedCategory: 0,
      dataonhire: [],
      dataoffhire: []
    };
  }

  UNSAFE_componentWillMount() {}

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      dataonhire: nextProps.dataonhire,
      dataoffhire: nextProps.dataoffhire
    });
  }

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "ship_id",
        label: "ID",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "shipname",
        label: "Vessel Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "call_sign",
        label: "Call Sign",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "flag",
        label: "Flag",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "date_created",
        label: "Last Update",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value) {
              return moment(value).format("DD-MM-YYYY HH:mm:ss");
            }
          }
        }
      },
      {
        name: "destination",
        label: "Destination",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "status_name",
        label: "Status Name",
        options: {
          filter: false,
          display: true
        }
      }
    ];
    const columns2 = [
      {
        name: "ship_id",
        label: "ID",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "shipname",
        label: "Vessel Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "call_sign",
        label: "Call Sign",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "flag",
        label: "Flag",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "date_created",
        label: "Last Update",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value) {
              return moment(value).format("DD-MM-YYYY HH:mm:ss");
            }
          }
        }
      },
      {
        name: "destination",
        label: "Destination",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "status_name",
        label: "Status Name",
        options: {
          filter: false,
          display: true
        }
      }
    ];
    const options1 = {
      filter: false,
      search: true,
      selectableRows: false,
      print: false,
      download: true,
      responsive: "scrollMaxHeight",
      viewColumns: false,
      rowsPerPage: [5],
      rowsPerPageOptions: [5, 10, 15],
      textLabels: {
        body: {
          noMatch: this.props.loader1
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };
    const options2 = {
      filter: false,
      search: true,
      selectableRows: false,
      print: false,
      download: true,
      // responsive: "scrollFullHeight",
      responsive: "scrollMaxHeight",
      viewColumns: false,
      rowsPerPage: [5],
      rowsPerPageOptions: [5, 10, 15],
      tableBodyWidth: "1em",
      textLabels: {
        body: {
          noMatch: this.props.loader2
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };
    return (
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container spacing={6}>
              <Grid item xs={12} lg={6}>
                <Grid container spacing={8}>
                  <Grid item xs={1}>
                    <div className={classes.iconBox}>
                      <Language style={{ color: "#FFF" }} />
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <p className={classes.cardTitle}>On Hire</p>
                  </Grid>
                </Grid>
                <MUIDataTable
                  data={this.state.dataonhire}
                  columns={columns}
                  options={options1}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container spacing={8}>
                  <Grid item xs={1}>
                    <div className={classes.iconBox}>
                      <Language style={{ color: "#FFF" }} />
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <p className={classes.cardTitle}>Off Hire</p>
                  </Grid>
                </Grid>
                <MUIDataTable
                  data={this.state.dataoffhire}
                  columns={columns2}
                  options={options2}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    );
  }
}

export default withStyles(styles)(Onoffhiretable);
